import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { DefaultButton } from "./defaultButton";
import { PrimaryButton } from "./primaryButton";
import { SecondaryButton } from "./secondaryButton";
import { ThirdaryButton } from "./thirdaryButton";

export interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	loading?: boolean;
	loadingColor?: string;
	buttonType?: "primary" | "secondary" | "default" | "thirded";
}
export const LoadingButton: React.FC<LoadingButtonProps> = ({
	loading,
	loadingColor = "white",
	buttonType = "primary",
	children,
	...htmlProps
}) => {
	const UsedButton =
		buttonType === "primary"
			? PrimaryB
			: buttonType === "secondary"
				? SecondaryB
				: buttonType === "thirded"
					? ThirdaryB
					: DefaultB;
	return (
		<UsedButton {...htmlProps} style={loading ? { pointerEvents: "none" } : undefined}>
			{children}
			{loading && (
				<Loader>
					<ClipLoader size={15} color={loadingColor} />
				</Loader>
			)}
		</UsedButton>
	);
};

const PrimaryB = styled(PrimaryButton)`
	position: relative;
	overflow: hidden;
`;
const SecondaryB = styled(SecondaryButton)`
	position: relative;
	overflow: hidden;
`;

const ThirdaryB = styled(ThirdaryButton)`
	position: relative;
	overflow: hidden;
`;
const DefaultB = styled(DefaultButton)`
	position: relative;
	overflow: hidden;
`;

const Loader = styled.div`
	background-color: inherit;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;
